<template>
  <div class="w100 pl20 pr20 pt20 pb20 bigbox">
    <div class="title">学期成绩统计查询</div>
    <div class="seachCla">
      <el-row :gutter="24">
        <el-col class="flex-box al-c" :span="4">
          <span class="mr10 tx-r" style="width: 40px">学期</span>
          <el-select
            v-model="searchData.semesterId"
            placeholder="请选择学期"
            @change="change"
          >
            <el-option
              v-for="item in semesterList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col class="flex-box al-c" :span="4">
          <span class="mr10 tx-r" style="width: 60px">专业科</span>
          <el-select
            v-model="searchData.orgNo"
            placeholder="请选择专业科"
            @change="changeOrgNo"
          >
            <el-option
              v-for="item in orgNameList"
              :key="item.orgNo"
              :label="item.orgName"
              :value="item.orgNo"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col class="flex-box al-c" :span="4">
          <span class="mr10 tx-r" style="width: 40px">专业</span>
          <el-select
            v-model="searchData.specialtyId"
            placeholder="请选择专业"
            @change="changeSpecial"
          >
            <el-option
              v-for="item in specialtyNameList"
              :key="item.specialtyId"
              :label="item.specialtyName"
              :value="item.specialtyId"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col class="flex-box al-c" :span="4">
          <span class="mr10 tx-r" style="width: 40px">年级</span>
          <el-select
            v-model="searchData.gradeId"
            placeholder="请选择年级"
            @change="changeGrade"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.gradeId"
              :label="item.gradeName"
              :value="item.gradeId"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col class="flex-box al-c" :span="4">
          <span class="mr10 tx-r" style="width: 40px">班级</span>
          <el-select
            v-model="searchData.classId"
            placeholder="请选择班级"
            @change="change"
          >
            <el-option
              v-for="item in classList"
              :key="item.classId"
              :label="item.className"
              :value="item.classId"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col class="flex-box al-c" :span="4">
          <span class="mr10 tx-r" style="width: 100px">任课教师</span>
          <el-input
            placeholder="请输入任课教师"
            v-model.trim="searchData.teacherName"
            clearable
          >
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="flex-end">
        <el-col class="flex-box al-c" :span="5">
          <span class="mr10 tx-r" style="width: 100px">课程名称</span>
          <el-input
            placeholder="请输入课程名称"
            v-model.trim="searchData.courseName"
            clearable
          >
          </el-input>
        </el-col>
        <el-col class="flex-box al-c" :span="5">
          <span class="mr10 tx-r" style="width: 100px">学生姓名</span>
          <el-input
            placeholder="请输入学生姓名"
            v-model.trim="searchData.studentName"
            clearable
          >
          </el-input>
        </el-col>
        <el-col class="flex-box al-c" :span="6">
          <el-button class="mb10 ml10" type="primary" @click="initPage"
            >查询</el-button
          >
          <el-button class="mb10 ml10" type="primary" @click="reset"
            >重置</el-button
          >
          <!-- <el-button class="mb10 ml10" type="primary" @click="downloadTemplate"
            >模板下载</el-button
          > -->
          <!-- <el-button class="mb10 ml10" type="primary" @click="importExcel"
            >导入</el-button
          > -->
          <el-button class="mb10 ml10" type="primary" @click="downloadExcel"
            >导出</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="table-con">
      <el-table
        class="table"
        header-row-class-name="table-head"
        row-class-name="cu-p"
        stripe
        :data="tableData"
        v-loading="loading"
      >
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">{{
            current * size - size + scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column
          prop="studentName"
          label="姓名"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="className"
          label="班级"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="courseName"
          label="课程名称"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="xqName"
          label="学期"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="teacherName"
          label="任课老师"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="headmaster"
          label="班主任"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="ps1"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps2"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps3"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps4"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps5"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps6"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps7"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps8"
          label="平时成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="kq"
          label="考勤成绩"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ps"
          label="平时成绩平均分"
          show-overflow-tooltip
          width="120"
        ></el-table-column>
        <el-table-column
          prop="dk"
          label="段考"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="qk"
          label="期考"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="qp"
          label="期评"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop=""
          label="备注"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
    <div class="mt20 flex-box pagegation">
      <div class="flex-1"></div>
      <el-pagination
        background
        @current-change="changePage"
        :current-page="current"
        :page-size="size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <importExcel
      ref="uplodModal"
      :uplodData="uplodData"
      @closeUplod="closeUplod"
      @successCallBack="saveSuccess"
      url="/hallportal/hq/postEmploy/export"
    ></importExcel>
  </div>
</template>

<script>
import {
  excelExport,
  jobDowlod,
  semesterList,
  gradeList,
  classList,
  finalGrade,
  getOrgNameList,
  getSpecialtyNameList,
} from "@/api/management/staff";
import importExcel from "@/components/dialog/import/importExcel.vue";
export default {
  name: "search",
  components: {
    importExcel,
  },
  props: [],
  data() {
    return {
      semesterList: [], //学期列表
      gradeList: [], //年级列表
      classList: [], //班级列表
      orgNameList: [], //专业科列表
      specialtyNameList: [], //专业列表
      searchData: {
        semesterId: "", //学期id
        gradeId: "", //年级id
        classId: "", //班级id
        studentName: "",
        courseName: "",
        orgNo: "",
        specialtyId: "", //专业id
        teacherName: "",
      },

      loading: false,
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      uplodData: {
        state: false,
        type: "",
      },
    };
  },
  computed: {},
  created() {
    this.getsemesterList().then(() => {
      this.initPage();
    });
    this.getOrgNameList();
  },
  mounted() {},
  destroyed() {},
  methods: {
    downloadExcel() {
      this.$DownLoad(
        excelExport(this.searchData),
        null,
        (res) => {
          if (res.status == 200) {
            // this.$message.success("开始下载");
          } else {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning",
            });
          }
        },
        (error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
        }
      );
    },
    initPage() {
      this.current = 1;
      this.getList();
    },
    change() {},
    // 获取专业科列表
    async getOrgNameList() {
      const { data } = await getOrgNameList();
      if (data.code == 0) {
        this.orgNameList = data.data;
      }
    },
    changeOrgNo() {
      this.specialtyNameList = [];
      this.searchData.specialtyId = "";
      this.gradeList = [];
      this.searchData.gradeId = "";
      this.searchData.classId = ''
      this.classList = []
      // 获取专业
      this.getSpecialtyNameList();
      // this.initPage();
    },
    //获取专业列表
    async getSpecialtyNameList() {
      const { data } = await getSpecialtyNameList(this.searchData.orgNo);
      if (data.code == 0) {
        this.specialtyNameList = data.data;
      }
    },
    // 专业改变查年级(传专业id，专业科id) 年级，班级都清空
    changeSpecial() {
      this.gradeList = [];
      this.searchData.gradeId = "";
      this.searchData.classId = ''
      this.classList = []
      this.getGradeList();
      // this.initPage();
    },
    // 获取年级
    async getGradeList() {
      const { data } = await gradeList({
        specialtyId: this.searchData.specialtyId,
        orgNo: this.searchData.orgNo,
      });
      if (data.code == 0) {
        this.gradeList = data.data;
      }
    },
    // 年级改变查班级
    changeGrade() {
      this.getClassList();
      this.searchData.classId = "";
      this.classList = [];
      // this.initPage();
    },
    // 班级列表
    async getClassList() {
      const { data } = await classList({
        gradeId: this.searchData.gradeId,
        orgNo: this.searchData.orgNo,
        specialtyId: this.searchData.specialtyId,
      });
      if (data.code == 0) {
        this.classList = data.data;
      }
    },
    // 获取学期信息
    async getsemesterList() {
      const { data } = await semesterList();
      if (data.code == 0) {
        this.semesterList = data.data;
        this.searchData.semesterId = this.semesterList[0].id;
      }
    },
    changePage(page) {
      this.current = page;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const params = {
        ...this.searchData,
        current: this.current,
        size: this.size,
      };
      const { data } = await finalGrade(params);
      this.loading = false;
      if (data.code == 0) {
        this.tableData = data.data.records;
        this.total = data.data.total;
      } else {
        this.$message.error(data.data.msg);
      }
    },
    reset() {
      this.searchData = {
        semesterId: "", //学期id
        gradeId: "", //年级id
        classId: "",
        studentName: "",
        courseName: "",
        orgNo: "",
        specialtyId: "", //专业id
        teacherName: "",
      };
      this.searchData.semesterId = this.semesterList[0].id;
      this.initPage();
    },
    closeUplod(val) {
      this.uplodData.state = val;
    },
    saveSuccess() {
      this.initPage();
    },
    importExcel() {
      this.uplodData.state = true;
    },
    // 模板下载
    downloadTemplate() {
      this.downloadFn(jobDowlod());
    },
    downloadFn(url) {
      this.$DownLoad(
        url,
        null,
        (res) => {
          if (res.status != 200) {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning",
            });
          }
        },
        (error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="less">
.bigbox {
  height: 100%;
  display: flex;
  flex-direction: column;
  .pagegation {
    width: 100%;
  }
  .flex-end {
    margin-top: 20px;
  }
}
.table-con {
  background-color: white;
  // overflow-y: auto;
  margin-top: 10px;
  width: 100%;
  flex: 1;
}
.seachCla {
  padding: 20px 20px 0px 20px;
  // background-color: #ffffff;
  width: 100%;
}
/deep/.el-table {
  width: 100%;
  .el-table__body-wrapper {
    max-height: calc(100vh - 390px);
    overflow-y: auto;
  }
}
.title {
  padding: 0px 0px 10px 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.box-flex {
  display: flex;
  // flex-wrap: wrap;
}
</style>
